import { twMerge } from 'tailwind-merge'

const Block = ({ children, className }) => {
  return (
    <div className={twMerge("flex flex-col py-6 md:py-8 px-4 md:px-10 bg-light_grey rounded-10", className)}>
      {children}
    </div>
  );
};

export default Block;
